import './competitiveanalysis.component.scss';
import { IMAGES_REPO } from '../../../static-resources';
import { useFindTool } from '../../home/hooks/use-capabilities.hook';
const coeffVizUrl = process.env.REACT_APP_COEFF_VIZ_PBI ?? '';
const CompetitiveAnalysisMenuComponent = () => {
  const scenarioPlannerTool = useFindTool('Price & Promo Simulator');

  return (
    <>
      <div className="menusub-title">Pricing Planning Tools</div>
      <ul className="megamenu-components">
        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.Calculator} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>
                  <a href={scenarioPlannerTool?.href}>
                    Price & Promo Simulator
                  </a>
                </h6>
                <p>
                  Simulate performance under different price and promo
                  configurations to support decision-making.{' '}
                </p>
                <p>Target users: RGM team</p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.ElasticViewer} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>
                  <a href={coeffVizUrl} target="_blank" rel="noreferrer">
                    Coefficient Visualizer
                  </a>
                </h6>
                <p>
                  Trends and estimates of key business-driver coefficients for
                  RGM decision-making
                </p>
                <p>Target users: RGM team</p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.RangeFinder} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>Range Finder</h6>
                <p>Coming Soon</p>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div className="d-flex navsubmenuitem">
            <div className="w-20">
              <div className="sideicon">
                <img src={IMAGES_REPO.PriceBandwidth} alt="" />
              </div>
            </div>
            <div className="w-80">
              <div className="navmenuitem ps-3">
                <h6>Pricing Bandwith</h6>
                <p>Coming Soon</p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </>
  );
};
export default CompetitiveAnalysisMenuComponent;
